<template>
  <div class="print-booking-confirm-main">
    <div class="booking-options">
      <div class="invoice-filters-and-table-box-controls">
        <div class="invoice-filters-summary-container">
          <span>{{ filterText }}</span>
        </div>
        <ButtonFilter
          buttonText="Change Filter"
          filterPosition="right"
          :filterWidth="420"
          :isOpen.sync="mainFilterIsOpen"
        >
          <div class="button-filter-content-container">
            <BoxContainer
              class="date-filter-container"
              :title="`Booking Date`"
              :isCheckBox="true"
              :isChecked.sync="dateFilterChecked"
            >
              <DateTimePicker
                :placeholder="`Start`"
                :value.sync="refreshStart"
                :showTime="false"
                :isDisabled="!dateFilterChecked"
              />
              <DateTimePicker
                :placeholder="`End`"
                :value.sync="refreshEnd"
                :showTime="false"
                :isDisabled="!dateFilterChecked"
              />
            </BoxContainer>

            <BoxContainer
              class="booking-no-filter-container"
              title="Search"
              :isChecked.sync="searchFilterChecked"
              :isCheckBox="true"
              style="margin-bottom: 5px"
            >
              <Dropdown
                placeholder="Search By"
                :items="searchFilterItems"
                itemKey="Search Criteria"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedSearchBy"
                :errorMessage.sync="searchByError"
                @selected="searchBySelected"
                validator="text,40"
              />
              <Dropdown
                placeholder="Search Criteria"
                :items="searchCriteriaItems"
                itemKey="name"
                :isDisabled="!searchFilterChecked || criteriaDisabled"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedCriteria"
                validator="text,40"
              />
              <Input
                placeholder="Search"
                :inputValue.sync="searchByValue"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :errorMessage.sync="searchByValueError"
              />
            </BoxContainer>
            <div class="refresh-button-container">
              <button @click="refreshFilterClicked" :disabled="!dateFilterChecked && !searchFilterChecked">
                Refresh
              </button>
            </div>
          </div>
        </ButtonFilter>
      </div>

      <div class="table-box-container">
        <TableBox
          :tableData="printList"
          title="Freight Booking"
          :selectedRow.sync="selectedFreightBooking"
          :loading="tableLoading"
          :selectedIndex="selectedIndex"
        />
      </div>
      <div class="details-block">
        <DateTimePicker
          style="margin-left: 2px; margin-top: 10px"
          placeholder="Date"
          title="Date"
          :value.sync="printDetails['Date']"
          :showTime="false"
          :maxDate="smallDateTimeMaxDate"
          :minDate="smallDateTimeMinValue"
          @dateChanged="checkDateTime('reportDate', $event)"
          :errorMessage.sync="errorMessages['reportDate']"
        />
      </div>
      <div class="details-block">
        <Input style="margin-right: 5px" placeholder="To" :inputValue.sync="printDetails['To']" validator="text,40" />
      </div>
      <div class="details-block">
        <Input
          style="margin-right: 5px"
          placeholder="Attn"
          :inputValue.sync="printDetails['Attn1']"
          validator="text,40"
        />
        <Input
          style="margin-right: 5px"
          placeholder="Tel #"
          :inputValue.sync="printDetails['Tel1']"
          validator="text,20"
        />
        <Input
          style="margin-right: 5px"
          placeholder="Fax #"
          :inputValue.sync="printDetails['Fax1']"
          validator="text,20"
        />
      </div>
      <div class="details-block">
        <Input style="margin-right: 5px" placeholder="CC" :inputValue.sync="printDetails['CC']" validator="text,40" />
      </div>
      <div class="details-block">
        <Input
          style="margin-right: 5px"
          placeholder="Attn"
          :inputValue.sync="printDetails['Attn2']"
          validator="text,40"
        />
        <Input
          style="margin-right: 5px"
          placeholder="Tel #"
          :inputValue.sync="printDetails['Tel2']"
          validator="text,20"
        />
        <Input
          style="margin-right: 5px"
          placeholder="Fax #"
          :inputValue.sync="printDetails['Fax2']"
          validator="text,20"
        />
      </div>
      <div class="details-block">
        <RemarksBox title="Remarks" :text.sync="printDetails['Remarks']" style="height: 60px" :maxLength="850" />
      </div>
      <div class="details-block">
        <Input placeholder="From" :inputValue.sync="printDetails['Regards']" validator="text,40" />
      </div>
      <div class="header-formatting-controls">
        <div class="header-formatting-column">
          <CheckBoxV2 title="Show Company Letter Head" :isChecked.sync="showCompanyLetterHeadIsChecked" />
        </div>
      </div>
      <div class="call-to-action-buttons">
        <button @click="previewClicked">Preview Report</button>
      </div>
    </div>
    <div class="report-preview">
      <DesignerV3
        v-if="showDesignerV3"
        :reportFiles="designerV3ReportFiles"
        :reportData="designerV3ReportData"
        :canToggleBackground="false"
        :canShare="true"
        :canClose="false"
        ref="designerV3"
      />
      <div v-else class="user-instructions">
        <span>Select Booking and click on <strong>Preview Report</strong> to get started</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      selectedIndex: [],
      routeWithBookingNo: false,
      mainFilterIsOpen: false,
      dateFilterChecked: true,
      searchFilterChecked: false,
      refreshStart: new Date(new Date().setDate(new Date().getDate() - 3)),
      refreshEnd: new Date(),
      searchFilterItems: [
        { 'Search Criteria': 'Booking #', '#': 1 },
        { 'Search Criteria': 'Job #', '#': 2 },
        { 'Search Criteria': 'BL No #', '#': 3 },
        { 'Search Criteria': 'Cargo Type', '#': 4 },
        { 'Search Criteria': 'Shipper/Consignee', '#': 5 },
        { 'Search Criteria': 'Billing Customer', '#': 6 },
        { 'Search Criteria': 'Project #', '#': 7 },
        { 'Search Criteria': 'Container #', '#': 8 },
        { 'Search Criteria': 'Transport Mode', '#': 9 },
        { 'Search Criteria': 'Customer Ref #', '#': 10 },
        { 'Search Criteria': 'Vessel Name', '#': 11 },
        { 'Search Criteria': 'Mother Vessel Name', '#': 12 },
        { 'Search Criteria': 'Vessel Booking Ref #', '#': 13 },
        { 'Search Criteria': 'User ID', '#': 14 },
        { 'Search Criteria': 'Container Type', '#': 15 },
        { 'Search Criteria': 'Goods Description', '#': 16 },
      ],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedSearchBy: null,
      criteriaDisabled: false,
      selectedCriteria: null,
      searchByValue: '',
      searchByError: '',
      searchByValueError: '',
      filterText: '',

      bookingDetails: null,
      printList: [],
      tableLoading: false,
      selectedBookingNo: '',
      loginDetails: null,
      printDetails: {
        Date: null,
        To: '',
        Attn1: '',
        Tel1: '',
        Fax1: '',
        CC: '',
        Attn2: '',
        Tel2: '',
        Fax2: '',
        Remarks: '',
        Regards: '',
      },
      showCompanyLetterHeadIsChecked: true,

      showDesignerV3: false,
      designerV3ReportFiles: [],
      designerV3ReportData: [],
      selectedFreightBooking: [],
      smallDateTimeMinValue: new Date(2000, 0, 1),
      smallDateTimeMaxDate: new Date(2079, 0, 1),
      errorMessages: {
        reportDate: '',
      },
    };
  },
  props: {},
  methods: {
    refreshFilterClicked: async function () {
      this.printList = [];
      this.selectedFreightBooking = [];
      this.selectedBookingNo = '';

      if (this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}, from ${new Date(this.refreshStart).formatString('yyyy-MM-dd')} to ${new Date(this.refreshEnd).formatString('yyyy-MM-dd')}`;
      } else if (this.dateFilterChecked && !this.searchFilterChecked) {
        this.filterText = `Filter by date from ${new Date(this.refreshStart).formatString('yyyy-MM-dd')} to ${new Date(this.refreshEnd).formatString('yyyy-MM-dd')}`;
      } else if (!this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}`;
      }

      const dataToPost = {
        stjobdate: this.dateFilterChecked ? new Date(this.refreshStart).formatString('yyyy-MM-dd') : '',
        edjobdate: this.dateFilterChecked ? new Date(this.refreshEnd).formatString('yyyy-MM-dd') : '',
        jobtype: 'E',
        searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
        searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
        searchvalue: this.searchFilterChecked ? this.searchByValue : '',
      };
      this.tableLoading = true;
      this.$fullscreenLoading('Getting Booking Details');
      this.printList = await this.$apiCallV2(`/FreightBooking/GetFreightBookingListing`, dataToPost);
      this.tableLoading = false;
      this.$fullscreenLoading();
      this.mainFilterIsOpen = false;
    },
    searchBySelected: function (e) {
      if (e) {
        if (e['Search Criteria'] == 'Required Date') {
          this.selectedCriteria = this.searchCriteriaItems[0];
          this.criteriaDisabled = true;
        } else {
          this.criteriaDisabled = false;
        }
      }
    },
    previewClicked: function () {
      this.mainFilterIsOpen = false;
      if (this.selectedFreightBooking.length == 0) {
        this.$showAlert('error', 'No Booking Selected', `Please select a record to Preview Booking Confirmation`);
      } else {
        if (this.checkDateTime('reportDate', this.printDetails['Date'])) {
          return;
        }
        this.selectedBookingNo = this.selectedFreightBooking[0]['Booking No'].trim();
        //this.refreshListing();
        this.previewBookingConfirmationReport();
      }
    },
    refreshListing: async function () {
      let dataToPost = {};
      if (this.routeWithBookingNo == false) {
        dataToPost = {
          stjobdate: this.dateFilterChecked ? new Date(this.refreshStart).formatString('yyyy-MM-dd') : '',
          edjobdate: this.dateFilterChecked ? new Date(this.refreshEnd).formatString('yyyy-MM-dd') : '',
          jobtype: 'E',
          searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
          searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
          searchvalue: this.searchFilterChecked ? this.searchByValue : '',
        };
      } else {
        dataToPost = {
          jobtype: 'E',
          searchfield: 'Booking #',
          searchcriteria: 'EQUALS',
          searchvalue: this.selectedBookingNo,
        };
      }
      this.tableLoading = true;
      this.$fullscreenLoading('Getting Booking Details');

      //reset to empty
      this.printList = [];
      this.selectedFreightBooking = [];

      //call api
      this.printList = await this.$apiCallV2(`/FreightBooking/GetFreightBookingListing`, dataToPost);
      this.tableLoading = false;

      if (this.printList.length > 0) {
        // Find the index of the booking that matches `selectedBookingNo`
        const index = this.printList.findIndex((item) => item['Booking No'] === this.selectedBookingNo);

        if (index !== -1) {
          this.$nextTick(() => {
            this.selectedFreightBooking = [this.printList[index]]; // Select the record
            this.selectedIndex = [index]; // Using this prop to highlight the row in TableBox, because the above code doesn't work
          });
        }
      }

      this.$fullscreenLoading();
    },
    previewBookingConfirmationReport: async function () {
      this.bookingDetails = null; //reset booking details
      this.designerV3ReportData = []; //reset report data

      this.bookingDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'FREIGHTBOOKING',
        recordid: this.selectedBookingNo,
      });

      this.$fullscreenLoading('Preparing to Print');

      //wrap object into array
      if (!Array.isArray(this.bookingDetails.Booking)) {
        this.bookingDetails.Booking = [this.bookingDetails.Booking];
      }

      //show hide fields on report
      if (
        this.printDetails['CC'] != '' ||
        this.printDetails['Attn2'] != '' ||
        this.printDetails['Tel2'] != '' ||
        this.printDetails['Fax2'] != ''
      ) {
        this.bookingDetails.Booking[0].showCC = true;
      } else {
        this.bookingDetails.Booking[0].showCC = false;
      }
      if (this.printDetails['Regards'] != '') {
        this.bookingDetails.Booking[0].showRegards = true;
      } else {
        this.bookingDetails.Booking[0].showRegards = false;
      }
      if (this.bookingDetails.Booking[0].Transshipment == '1') {
        this.bookingDetails.Booking[0].showTranshipment = true;
      } else {
        this.bookingDetails.Booking[0].showTranshipment = false;
      }
      if (this.bookingDetails.Booking[0]['Cargo Type'] == 'FCL') {
        this.bookingDetails.Booking[0].isFCL = true;
      } else {
        this.bookingDetails.Booking[0].isFCL = false;
      }
      if (this.bookingDetails.Booking[0]['Insurance'] == '1') {
        this.bookingDetails.Booking[0]['Insurance'] = 'Yes';
      } else {
        this.bookingDetails.Booking[0]['Insurance'] = 'No';
      }

      //insert user input into report data
      this.bookingDetails.Booking[0].Date =
        this.printDetails['Date'] ? this.$dateTime.getDateTime(this.printDetails['Date'], 'dd/MM/yyyy') : '';
      this.bookingDetails.Booking[0].To = this.printDetails['To'];
      this.bookingDetails.Booking[0].Attn1 = this.printDetails['Attn1'];
      this.bookingDetails.Booking[0].Tel1 = this.printDetails['Tel1'];
      this.bookingDetails.Booking[0].Fax1 = this.printDetails['Fax1'];
      this.bookingDetails.Booking[0].CC = this.printDetails['CC'];
      this.bookingDetails.Booking[0].Attn2 = this.printDetails['Attn2'];
      this.bookingDetails.Booking[0].Tel2 = this.printDetails['Tel2'];
      this.bookingDetails.Booking[0].Fax2 = this.printDetails['Fax2'];
      this.bookingDetails.Booking[0].Remarks = this.printDetails['Remarks'];
      this.bookingDetails.Booking[0].Regards = this.printDetails['Regards'];

      //reformat dates
      this.bookingDetails.Booking[0]['POL ETA'] =
        this.bookingDetails.Booking[0]['POL ETA'] ?
          this.$dateTime.getDateTime(this.bookingDetails.Booking[0]['POL ETA'], 'dd/MM/yyyy')
        : '';
      this.bookingDetails.Booking[0]['POD ETA'] =
        this.bookingDetails.Booking[0]['POD ETA'] ?
          this.$dateTime.getDateTime(this.bookingDetails.Booking[0]['POD ETA'], 'dd/MM/yyyy')
        : '';
      this.bookingDetails.Booking[0]['POT ETD'] =
        this.bookingDetails.Booking[0]['POT ETD'] ?
          this.$dateTime.getDateTime(this.bookingDetails.Booking[0]['POT ETD'], 'dd/MM/yyyy')
        : '';
      this.bookingDetails.Booking[0]['Final Destination ETA'] =
        this.bookingDetails.Booking[0]['Final Destination ETA'] ?
          this.$dateTime.getDateTime(this.bookingDetails.Booking[0]['Final Destination ETA'], 'dd/MM/yyyy')
        : '';

      //reformat goods desc (combine)
      if (this.bookingDetails.Booking[0]['GoodsDesc'] && this.bookingDetails.Booking[0]['GoodsDesc'].length > 0) {
        this.bookingDetails.Booking[0]['Goods Description'] = this.bookingDetails.Booking[0]['GoodsDesc']
          .map((item) => item.GoodsDescription)
          .join('<br>');
      }

      //reformat package details (TBA if empty/0)
      if (
        this.bookingDetails.Booking[0]['Package Code'] == '' ||
        this.bookingDetails.Booking[0]['Package Code'] == null
      ) {
        this.bookingDetails.Booking[0]['Package Desc'] = 'TBA';
      }
      if (this.bookingDetails.Booking[0]['Volume'] == '' || this.bookingDetails.Booking[0]['Volume'] == '0') {
        this.bookingDetails.Booking[0]['Volume'] = 'TBA';
      } else {
        this.bookingDetails.Booking[0]['Volume'] = this.bookingDetails.Booking[0]['Volume'] + ' M3';
      }
      if (
        this.bookingDetails.Booking[0]['Gross Weight'] == '' ||
        this.bookingDetails.Booking[0]['Gross Weight'] == '0'
      ) {
        this.bookingDetails.Booking[0]['Gross Weight'] = 'TBA';
      } else {
        this.bookingDetails.Booking[0]['Gross Weight'] = this.bookingDetails.Booking[0]['Gross Weight'] + ' KGS';
      }

      //format agent address
      if (this.bookingDetails?.Booking?.[0]?.['Oversea Agent']) {
        const agent = this.bookingDetails.Booking[0];

        const addr1 = agent['OA Addr1'] || '';
        const addr2 = agent['OA Addr2'] || '';
        const addr3 = agent['OA Addr3'] || '';
        const addr4 = agent['OA Addr4'] || '';
        const postCode = agent['OA PostCode'] || '';
        const city = agent['OA City'] || '';
        const state = agent['OA State'] || '';

        this.bookingDetails.Booking[0]['OA Address'] =
          `${addr1}<br>${addr2}<br>${addr3}<br>${addr4}<br>${postCode}${postCode ? ', ' : ''}${city}${city ? ', ' : ''}${state}`;
      }

      this.detailDateTime = `${this.listingDAte} ${this.listingTime}`;

      //set company letter head
      if (this.showCompanyLetterHeadIsChecked == true) {
        this.bookingDetails.Booking[0].showHeader = true;
        this.bookingDetails.Booking[0]._header = `https://dsmapi.logistics.systems/logo/CoHeaderOpr_${this.loginDetails.CoRefname}.png`;
      } else {
        this.bookingDetails.Booking[0].showHeader = false;
        this.bookingDetails.Booking[0]._header = '';
      }

      this.designerV3ReportFiles = ['BookingConfirmationFRE.json'];

      this.designerV3ReportData = this.bookingDetails.Booking;
      this.showDesignerV3 = true;

      this.$fullscreenLoading();
    },
    checkDateTime: function (field, date) {
      if (date != null && date != '') {
        if (date > this.smallDateTimeMaxDate) {
          const errMsg = `Please select date earlier than ${this.smallDateTimeMaxDate.formatString('yyyy-MM-dd')}`;
          if (field == 'reportDate') {
            this.errorMessages['reportDate'] = errMsg;
          }
          return true;
        } else if (date < this.smallDateTimeMinValue) {
          const errMsg = `Please select date later than ${this.smallDateTimeMinValue.formatString('yyyy-MM-dd')}`;
          if (field == 'reportDate') {
            this.errorMessages['reportDate'] = errMsg;
          }
          return true;
        }
      }
    },
  },
  async mounted() {
    this.$fullscreenLoading('Getting Login Details');
    this.loginDetails = await this.$apiCallV2('/Login/GetDetails');
    this.$fullscreenLoading();

    if (this.$route.query['bookingno']) {
      this.selectedBookingNo = this.$route.query['bookingno'];
      this.routeWithBookingNo = true;

      this.dateFilterChecked = false;
      this.searchFilterChecked = true;
      this.searchByValue = this.selectedBookingNo;

      this.refreshListing();
      //this.previewBookingConfirmationReport(); removed auto preview
    } else {
      this.selectedBookingNo = '';
      this.routeWithBookingNo = false;
      this.refreshFilterClicked();
    }

    if (!this.selectedSearchBy) {
      this.selectedSearchBy = this.searchFilterItems[0];
    }

    if (!this.selectedCriteria) {
      this.selectedCriteria = this.searchCriteriaItems[2];
    }
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';

.print-booking-confirm-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  overflow: hidden;

  > .booking-options {
    margin-right: 2.5px;
    flex: 1;
    background-color: white;
    padding: 5px;
    width: 50%;
    overflow-y: auto;
    height: 100%;

    > .table-box-container {
      height: 50%;
      // height: 50%; // ============ change later
    }

    > .details-block {
      display: flex;
      width: 100%;
      position: relative;
      margin-bottom: 2px;

      > .details-column {
        width: calc(100% / 3);
        margin-right: 5px;
      }
    }

    > .call-to-action-buttons {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }

    > .invoice-filters-and-table-box-controls {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-bottom: 5px;

      > .invoice-filters-summary-container {
        margin-right: 5px;
        align-content: center; // vertically align the summary text
        text-align: end; // horizontally align the summary text
      }

      .button-filter-content-container {
        text-align: left;
        cursor: auto;

        .invoice-no-filter-container {
          margin-top: 15px;
        }

        .customer-filter-container {
          margin-top: 15px;
        }

        .outstanding-and-job-type-filters {
          display: flex;
          flex-direction: row;

          > .outstanding-dropdown {
            margin-right: 5px;
          }

          > .job-type-dropdown {
            margin-left: 5px;
          }
        }

        .not-printed-filter {
          margin-top: 5px;
          display: flex;
          justify-content: flex-start;
        }

        .refresh-button-container {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
        }
      }

      > .select-deselect-all-button {
        margin-left: 5px;
      }
    }
  }

  > .report-preview {
    margin-left: 2.5px;
    flex: 1;
    background-color: white;
    padding: 5px;

    > .user-instructions {
      height: 100%;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      font-size: 20px;
    }
  }
}
</style>
